import React from 'react';
import { T, Tooltip } from '@colonist/ui';
import { useUIGameTranslationContext } from '../../../../../contexts/UIGameTranslationContext.tsx';
export const TooltipResourceCards = ({ resourceCardDiscardLimit, children })=>{
    const { translationKeyContext } = useUIGameTranslationContext();
    return /*#__PURE__*/ React.createElement(Tooltip, {
        title: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.resourceCard.title',
                options: {
                    context: translationKeyContext
                }
            }
        }),
        content: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.resourceCard.body',
                options: {
                    context: translationKeyContext
                }
            }
        })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(T, {
            id: {
                key: 'strings:game.playerInformation.resourceCard.discardLimitTip',
                options: {
                    count: resourceCardDiscardLimit
                }
            }
        })))
    }, children);
};
